<div class="overViewStatus">
     <div class="edit-button-style" (click)="openEditOverViewStatus()">
        <img alt="edit" src="/assets/img/edit-icon.svg" > Edit        
    </div>
    <snl-side-panel panelType="close" [headerName]="headerName" size="large" [(isOpen)]="openEditStatus">
        <div sidePanelContent class="statusPointSidePanel largeSidepanelWidth overViewStatus">
            <ng-container *ngIf="editOverViewStatus === 'statusPending'">
                <div class="statusPending">
                    <div class="currentStatus">
                        <p class="body-b1 ">Current status</p>
                        <p class="section-title fleet-section-title">{{editStatusDetails?.currentStatus}}</p>
                    </div>
                     <div class="currentStatus currentActivationDate">
                        <p class="body-b1 ">Current activation date</p>
                        <p class="section-title fleet-section-title">{{editStatusDetails?.currentActivationDate | date:'dd MMM yyyy'}}</p>
                    </div>
                    <div class="effective-date datePickerStatus">
                        <snl-date-picker-dropdown datePickerType="date"
                        (selectedDate)="selectedStatusDate($event)"
                        [min]="disableFYdate"
                        title="Effective date of change"></snl-date-picker-dropdown>
                    </div>
                    <div class="multi-input editOverViewReason">
                        <snl-multi-line-input 
                            [label]="'Reason for change'" 
                            [maxLength]="maxLength" 
                            [isError]="isTextError"
                            (fieldValue)="statusFieldValue($event)">
                        </snl-multi-line-input>
                    </div>         
                </div>
            </ng-container>
            <ng-container *ngIf="editOverViewStatus === 'statusActive_Inactive'">
                <div class="statusPending statusActive">
                    <!-- ---deactivate -->
                    <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true && shipDetailsbasicinfo?.statusInfo?.futureChange === false && shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Active'">
                        <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.wasPreviouslyInactive === true">
                            <div class="currentStatus">
                                <p class="body-b1 ">Current status</p>
                                <p class="section-title fleet-section-title">{{editStatusDetails?.currentStatus}}</p>
                            </div>
                            <!-- <div class="currentStatus currentActivationDate">
                                <p class="body-b1 ">Current activation date</p>
                                <p class="section-title fleet-section-title">{{editStatusDetails?.currentActivationDate | date:'dd MMM yyyy'}}</p>
                            </div> -->

                            <div class="effective-date datePickerStatus">
                                <snl-date-picker-dropdown datePickerType="date"
                                (selectedDate)="selectedActiveFutureDate($event)" 
                                [min]="minSelectableDate"
                                title="Effective date of change"></snl-date-picker-dropdown>
                            </div>
                            <div class="multi-input editOverViewReason">
                                <snl-multi-line-input 
                                    [label]="'Reason for change'" 
                                    [maxLength]="maxLength" 
                                    [isError]="isTextError"
                                    (fieldValue)="statusActiveFutureFieldValue($event)">
                                </snl-multi-line-input>
                            </div>  
                        </ng-container>
                        <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.wasPreviouslyInactive === false">
                            <div class="currentStatus">
                                <p class="body-b1 ">Current status</p>
                                <p class="section-title fleet-section-title">{{editStatusDetails?.currentStatus}}</p>
                            </div>
                            <div class="currentStatus currentActivationDate">
                                <p class="body-b1 ">Current activation date</p>
                                <p class="section-title fleet-section-title">{{editStatusDetails?.currentActivationDate | date:'dd MMM yyyy'}}</p>
                            </div>
                        </ng-container>
                    </ng-container>    
                    <!-- --upcoming -->
                    <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === false && shipDetailsbasicinfo?.statusInfo?.futureChange === true">
                        <div class="notificationWrap" *ngIf="showDiscardEditBanner">         
                            <div class="notificationData body-b1">                        
                                <figure>
                                    <img src="assets/img/infoBlue.svg" alt="information">
                                </figure>
                                                            
                                <span class="notificationData_text">To change the current details, you need
                                    to discard the upcoming change first.</span>                  
                            </div>
                        </div>
                        <div class="currentStatus">
                            <p class="body-b1 ">Current status</p>
                            <p class="section-title fleet-section-title">{{editStatusDetails?.currentStatus}}</p>
                        </div>
                        <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.wasPreviouslyInactive === true">
                            <div class="currentStatus currentActivationDate">
                                <p class="body-b1 ">Effective date of change</p>
                                <p class="section-title fleet-section-title">{{editStatusDetails?.currentActivationDate | date:'dd MMM yyyy'}}</p>
                            </div>
                            <div class="currentStatus activeReason">
                                <p class="body-b1 ">Reason for change</p>
                                <p class="section-title fleet-section-title"></p>
                            </div>
                        </ng-container>
                        <div class="single-line"></div>
                        <div class="activeUpcomingStatus">
                            <div class="upCommingChange">
                                <span class="body-b1 upcomingTitle">Upcoming status</span>
                                <span class="section-title fleet-section-title">{{editStatusDetails?.upcomingChange?.status}}</span>
                            </div>
                            <div class="discardWrap" >
                                <figure (click)="discardEditStatusEvent()">
                                    <img src="assets/img/delBlue.svg" alt="information">
                                </figure>                     
                                <span class="discardText section-title" (click)="discardEditStatusEvent()">Discard</span>
                            </div> 
                            <div class="effective-date datePickerUpcomingEditStatus">
                                <snl-date-picker-dropdown datePickerType="date"
                                    (selectedDate)="upComingEditStatusDate($event)"
                                    [min]="minSelectableDate"
                                    title="Effective date deactivation">
                                </snl-date-picker-dropdown>
                                <div class="updateDate datePickerUpcomingEdit_StatusDate section-title" *ngIf="upComingStatusDate">
                                    {{upComingStatusDate | date:'dd MMM yyyy'}}
                                </div>
                            </div>
                            <div class="multi-input upComingReasonEditStatus editOverViewReason">
                                <snl-multi-line-input 
                                    [label]="'Reason for deactivation'"
                                    [maxLength]="maxLength"
                                    [isError]="isTextError"
                                    (fieldValue)="upComingEditStatusValue($event)">
                                </snl-multi-line-input>
                                <span class="upComingEdit_StatusReasons section-title" *ngIf="upComingStatusReason">{{upComingStatusReason}}</span>
                            </div>
                        </div>
                    </ng-container> 
                    <!-- ---restore -->
                    <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true && shipDetailsbasicinfo?.statusInfo?.futureChange === false && shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Inactive' && openEditStatus === true">
                        <div class="notificationWrap">               
                            <div class="notificationData body-b1">                          
                                <figure>
                                    <img src="assets/img/infoBlue.svg" alt="information">
                                </figure>                                           
                                <span class="notificationData_text">You can modify the details until <span class="dateScrubber section-title color__primary fw-700">{{shipDetailsbasicinfo?.statusInfo?.nextCalculationDate | date:'dd MMM yyyy' }}</span>  without affecting distrubtion.</span>                     
                            </div>
                        </div>
                        <div class="currentStatus">
                            <p class="body-b1 ">Current status</p>
                            <p class="section-title fleet-section-title">{{editStatusDetails?.currentStatus}}</p>
                        </div>
                        <div class="effective-date datePickerStatus">
                            <snl-date-picker-dropdown datePickerType="date"
                                [min]="minSelectableDate"
                                [startMonthDate]="selectedPendingStatusDate"
                                (selectedDate)="pendingEditStatusDate($event)"
                                title="Effective date of change">
                            </snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input editOverViewReason">
                            <snl-multi-line-input 
                                [label]="'Reason for change'" 
                                [maxLength]="maxLength" 
                                [isError]="isTextError"
                                [value]="pendingEditStatusReason"
                                (fieldValue)="pendingEditStatusValue($event)">
                            </snl-multi-line-input>
                        </div>
                        <div class="single-line"></div>
                        <div class="previousStatus">
                            <div class="currentStatus">
                                <p class="body-b1 ">Previous status</p>
                                <p class="section-title fleet-section-title">{{editStatusDetails?.previousStatus}}</p>
                            </div>
                             <div class="restoreWrap" (click)="restoreEditStatusEvent()" *ngIf="shipDetailsbasicinfo?.statusInfo?.previousStatus !== null">
                                <figure>
                                    <img src="assets/img/arrowLeftIcon.svg" alt="arrowLeftIcon">
                                </figure>                 
                                <span class="restoreText section-title fw-700">Restore previous</span>
                            </div> 
                            <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.wasPreviouslyInactive === true">
                                <div class="currentStatus pendingEditStatusDateWrap">
                                    <p class="body-b1">Effective date of change</p>
                                    <p class="section-title fleet-section-title">{{editStatusDetails?.previousActivationDate | date:'dd MMM yyyy'}}</p>
                                </div>
                                <div class="resonForChange">
                                    <p class="body-b1">Reason for change</p>
                                    <p class="section-title fleet-section-title">{{editStatusDetails?.previousReason}}</p>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.wasPreviouslyInactive === false">
                                <div class="currentStatus pendingEditStatusDateWrap">
                                    <p class="body-b1">Date of activation</p>
                                    <p class="section-title fleet-section-title">{{editStatusDetails?.previousActivationDate | date:'dd MMM yyyy'}}</p>
                                </div>
                            </ng-container>    
                        </div>            
                    </ng-container>     
                </div>
            </ng-container>
        </div>
        <div sidePanelFooterContent>
           <ng-container *ngIf="editOverViewStatus === 'statusPending'">
                <snl-button class="" type="primary" size="large"
                    (click)="openEditStatus = false;updateEditStatus()" 
                    [disabled]="!selectedStatusDateVal || statusReason ==='' || statusReasonError">
                        Save and update
                    </snl-button>
                <snl-button type="secondary" size="large" (click)="openEditStatus = false;cancelEditStatus()">Cancel</snl-button>
           </ng-container>
           <ng-container *ngIf="editOverViewStatus === 'statusActive_Inactive'">
                <!-- deactivate -->
                <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true && shipDetailsbasicinfo?.statusInfo?.futureChange === false && shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Active'">
                    <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.wasPreviouslyInactive === true">
                        <snl-button class="" type="primary" size="large"  (click)="openEditStatus = false;
                        " [disabled]="!isActiveFutureDateText || !isActiveFutureReason || isActiveFutureReasonError">
                            Save and update
                        </snl-button>
                        <snl-button type="secondary" class="deActivateClass" size="large" (click)="getDeactivateModal()">Deactivate</snl-button>
                    </ng-container>
                    <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.wasPreviouslyInactive === false">
                        <ng-container *ngIf="editStatusDetails?.currentStatus === 'Inactive'">
                            <snl-button class="" type="primary" size="large"  (click)="openEditStatus = false;">
                                Save and update
                            </snl-button>
                            <snl-button type="secondary" class="deActivateClass" size="large">Activate</snl-button>
                        </ng-container>
                        <ng-container *ngIf="editStatusDetails?.currentStatus === 'Active'">
                            <snl-button class="" type="primary" size="large" (click)="openEditStatus = false;">
                                Close
                            </snl-button>
                            <snl-button type="secondary" class="deActivateClass" size="large" (click)="getDeactivateModal()">Deactivate</snl-button>
                        </ng-container>                  
                    </ng-container>
                </ng-container>
                <!-- --upcoming -->
                <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === false && shipDetailsbasicinfo?.statusInfo?.futureChange === true">
                    <snl-button class="" type="primary" size="large"
                        (click)="openEditStatus = false;updateEditStatus()" 
                        [disabled]="!selectedupComingEditStatusDate || selectedupComingEditStatusReason ==='' || upComingEditStatusReasonError || !discardSuccessEdit">
                        Save and update
                    </snl-button>
                    <snl-button type="secondary" size="large" (click)="openEditStatus = false;cancelEditStatus()">Cancel</snl-button>
                </ng-container>
                <!-- ---restore -->
                <ng-container *ngIf="shipDetailsbasicinfo?.statusInfo?.pastOrTodayChange === true && shipDetailsbasicinfo?.statusInfo?.futureChange === false && shipDetailsbasicinfo?.statusInfo?.currentStatus ==='Inactive'">
                    <snl-button class="" type="primary" size="large"
                        (click)="openEditStatus = false;updateEditStatus()" 
                        [disabled]="!selectedPendingStatusDate || pendingEditStatusReason ==='' || pendingEditStatusReasonError">
                        Save and update
                    </snl-button>
                    <snl-button type="secondary" size="large" (click)="openEditStatus = false;cancelEditStatus()">Cancel</snl-button>
                </ng-container>
           </ng-container>
        </div>
    </snl-side-panel>
</div>

<!----- deactivate modal---- -->

<snl-modal (click)="openDeactivateStatus = false" [type]="'small'" [open]="openDeactivateStatus">
  <div slot="heading" class="ppLargeModalHeading"> Deactivate {{shipDetailsbasicinfo?.vslName}}</div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="body-b1 color__primary">
            <div class="deactivteTxt">
                Deactivating this ship will <span class="section-title">impact</span> the <span class="section-title">distribution calculation</span>, according to the effective date of deactivation.
            </div>
            <br/>
            <div class="reactivateTxt">
                You can reactivate it later.
            </div>  
            <ng-container *ngIf="openDeactivateStatus">          
                <div class="effective-date deactivateModal mt-16">
                    <snl-date-picker-dropdown datePickerType="date"
                        (selectedDate)="selectedDeactivateDate($event)" 
                        [min]="minSelectableDate"
                        title="Effective date deactivation">
                    </snl-date-picker-dropdown>
                </div>
                <div class="multi-input daectivateInput mt-16">
                    <snl-multi-line-input 
                        [label]="'Reason for change'" 
                        [maxLength]="maxLength" 
                        [isError]="isTextError"
                        (fieldValue)="statusDeactivateFieldValue($event)">
                    </snl-multi-line-input>
                </div> 
            </ng-container> 
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
        <snl-button type="secondary" size="large" (click)="openDeactivateStatus = false; cancelDeactivate()">Cancel</snl-button>
        <snl-button type="primary" size="large" class="deActivateModalClass" [ngClass]="!deactivateDateText || !deactivateReasonText || deactivateReasonError ? 'errorDeactivateModal' : ''"
            (click)="openDeactivateStatus = false;getDeactivateEvent()" [disabled] ="!deactivateDateText || !deactivateReasonText || deactivateReasonError">
            Deactivate
        </snl-button> 
    </div>
  </div>
</snl-modal>


<!-- ----discard---- -->

<snl-modal (click)="openDiscardEditStatus = false" [type]="'small'" [open]="openDiscardEditStatus">
  <div slot="heading" class="ppLargeModalHeading"> Discard upcoming change </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="body-b1 color__primary">
            You are about to cancel the scheduled status change, effective from 
            <span class="section-title">
                <!-- {{poolPointDetails?.upcomingEffectiveDate | date:'dd MMM yyyy'}} -->
                 {{editStatusDetails?.upcomingChange?.effectiveDate | date:'dd MMM yyyy'}}
            </span>
            <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openDiscardEditStatus = false;discardEditStatusChange()">Discard</snl-button>
      <snl-button type="secondary" size="large" (click)="openDiscardEditStatus = false;cancelDiscard()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>


<!-- -----restore---- -->

 <snl-modal (click)="openRestoreEditStatus = false" [type]="'small'" [open]="openRestoreEditStatus">
  <div slot="heading" class="ppLargeModalHeading"> Restore previous status change </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="color__primary body-b1">
           You are about to change the current status change back to the previous configuration. 
           <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openRestoreEditStatus = false;restoreEditStatusChanges();">Restore</snl-button>
      <snl-button type="secondary" size="large" (click)="openRestoreEditStatus = false;cancelRestoreStatus()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>